import {EventBus} from "../../../events/EventBus";
import {SelectChangeEvent, SelectChangeEventPayload} from "../../../events/Events";

const eventBus = EventBus.getInstance();
const selectElements = document.querySelectorAll('.js-wl-select');

selectElements.forEach((element) => {
    const selectElement = element as HTMLSelectElement;
    let selectElementName = selectElement.name;
    if(selectElementName == undefined) {
        selectElementName = <string>selectElement.dataset.name
    }

    selectElement.addEventListener("change", (event) => {
        const target = event.target as HTMLOptionElement;
        const inputElement = document.querySelector("#"+selectElement.id);
        if(inputElement != null) {
            const selectedInputLabel = document.querySelector("label[for='"+target.id+"']")?.innerHTML;
            if(selectedInputLabel != undefined) {
                inputElement.setAttribute("placeholder", selectedInputLabel);
            }
        }
        eventBus.emit(new SelectChangeEvent({
            id: selectElement.id,
            name: selectElementName,
            value: target.value
        }));
    });
});

